import React from 'react'
import { Button } from '../../../../../components/Button/Button'
import { Modal } from '../../../../../components/Modal/Modal'

export interface DeleteManualParticipantModalProps {
  show: boolean
  participantName: string
  showUnshareWarning: boolean
  loading: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const DeleteManualParticipantModal: React.FC<DeleteManualParticipantModalProps> = React.memo(
  ({ show, participantName, showUnshareWarning, loading, onCancel, onConfirm }) => {
    return (
      <Modal
        show={show}
        onHide={onCancel}
        centered={true}
        header={<h4>Remove participant</h4>}
        headerBodySeparator={true}
        body={
          <p className='paragraph-small'>
            {showUnshareWarning ? (
              <>
                <span>{`Meeting will not be shared with `}</span>
                <strong>{participantName}</strong>
                <span>{' after removing.'}</span>
              </>
            ) : (
              <>
                <strong>{participantName}</strong>
                <span>{' will be removed from the meeting'}</span>
              </>
            )}
          </p>
        }
        footer={
          <div className='d-flex flex-grow-1 justify-content-end gap-3'>
            <Button variant='secondary' className='px-3 py-2 button-medium' onClick={onCancel} disabled={loading}>
              Cancel
            </Button>
            <Button variant='primary' className='px-3 py-2 button-medium' onClick={onConfirm} loading={loading}>
              Remove
            </Button>
          </div>
        }
        bodyClassName='pb-0'
        footerClassName='px-4 pb-4 pt-0'
      />
    )
  },
)
